import apiClient from '@/shared/services/apiClient';

/**
 * Employer-dashboard BioMatch reporting client. Returns
 * de-identified per-program aggregates for an organization. Used by
 * the OHD dashboard's program cards.
 */

export interface ProgramReportingRow {
    recommendation_id: number;
    recommendation_name: string;
    risk_tier: string | null;
    kit_sku: string | null;
    active_enrollments: number;
    cancelled_enrollments: number;
    completed_enrollments: number;
    pending_fulfillment: number;
    shipped_count: number;
    lab_addon_pending: number;
    lab_addon_complete: number;
    home_kit_total: number;
    lab_addon_total: number;
    patient_total_cents: number;
    employer_total_cents: number;
}

export interface ProgramDailyPoint {
    recommendation_id: number;
    day: string;
    enrollments: number;
}

export const BioMatchReportingService = {
    async getProgramReporting(orgId: number): Promise<ProgramReportingRow[]> {
        return apiClient.get<ProgramReportingRow[]>(`/api/admin/biomatch/reporting?orgId=${orgId}`);
    },

    async getProgramDailyEnrollments(orgId: number, days = 30): Promise<ProgramDailyPoint[]> {
        return apiClient.get<ProgramDailyPoint[]>(
            `/api/admin/biomatch/reporting/daily?orgId=${orgId}&days=${days}`
        );
    },
};

export default BioMatchReportingService;
